import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ModifiersFacade } from './+state/modifiers.facade';
import { ModifiersStateModule } from './+state/modifiers.state.module';
import { ModifiersService } from './services/modifiers.service';

@NgModule({
  imports: [CommonModule, ModifiersStateModule],
})
export class DomainModifiersModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainModifiersModule,
      providers: [ModifiersService, ModifiersFacade],
    };
  }
}
